import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import "./Leads.css";

const ProductCard = ({ imageSrc, msrp, sku, lowPrice, title, addedDate }) => (
  <div className="product-card">
    <img className="product-image" src={imageSrc} alt="product" />
    <div className="product-info">
      <div className="product-title">{title}</div>
      <div className="product-prices">
        <span>MSRP: {msrp}</span>
        <span>Low As: {lowPrice}</span>
        <span>UPC: {sku}</span>
      </div>
      <div className="product-actions">
        <div className="action-button go-to-product">Go To Product</div>
        <div className="action-button save-for-later">Save for Later</div>
      </div>
      <div className="product-added">Added {addedDate}</div>
    </div>
  </div>
);

export const Leads = ({ selectedStore }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      let filePath;
      switch (selectedStore) {
        case "walmart":
          filePath = "/data/walmart.csv";
          break;
        case "target":
          filePath = "/data/target.csv";
          break;
        default:
          return;
      }

      const response = await fetch(filePath);
      const data = await response.text();
      Papa.parse(data, {
        header: true,
        complete: (results) => setProducts(results.data),
      });
    };

    fetchProducts();
  }, [selectedStore]);

  return (
    <div className="leads-container">
      <div className="leads-header">
        <img
          className="walmart-logo"
          src={"/icons/logo.svg"}
          alt={`${selectedStore} logo`}
        />
        <div className="walmart-deals">{selectedStore} Deals</div>
      </div>

      <div className="search-bar">
        <img className="search-icon" src="/icons/search.png" alt="search icon" />
        <input className="search-input" placeholder="Search Listings" />
      </div>

      <div className="product-container">
        <div className="product-list">
          {products.map((product, index) => (
            <ProductCard
              key={index}
              imageSrc={product["Product Image URL"]}
              msrp={product["Old Price"]}
              lowPrice={product["New Price"]}
              sku={product["SKU/UPC"]}
              title={product["Item Name"]}
              addedDate="N/A" // Adjust if you have date
            />
          ))}
        </div>
      </div>
    </div>
  );
};
